import { object, string } from "yup"
import { buildSchema } from "./util/build-schema"

export const MAX_PASSKEY_NAME_LENGTH = 64

const schema = object({
  name: string().trim().max(MAX_PASSKEY_NAME_LENGTH).required(),
})

export const passkeySchema = buildSchema("Passkey", schema)
